// extracted by mini-css-extract-plugin
module.exports = {"link":"_b5421a88","icon":"_bc4dda63","placeholder":"_d41fcd2b"};